import React from 'react';
import { ScrollView, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { sharedStyles } from '../OnboardingSharedStyles';
import { EquipmentType } from '../../utils/equipmentUtils';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';

import BodyWeightIcon from '../../assets/images/icon-bodyweight-outline.svg';
import DumbbellsIcon from '../../assets/images/icon-dumbbells-outline.svg';
import BenchAndDumbbellsIcon from '../../assets/images/icon-bench-and-dumbbells-outline.svg';
import BenchIcon from '../../assets/images/icon-bench-outline.svg';

interface IEquipmentSelectionViewProps {
  t: (key: string) => string;
  selectedEquipment: EquipmentType | null;
  onEquipmentSelect: (equipmentType: EquipmentType) => void;
}

export function EquipmentSelectionView({
  t,
  selectedEquipment,
  onEquipmentSelect,
}: IEquipmentSelectionViewProps) {
  return (
    <ScrollView>
      <View style={{ flex: 1, marginTop: defaultScale(24) }}>
        <SelectionContainer
          title={t('settings:bodyweightOnly')}
          subTitle={t('settings:noEquipment')}
          icon={(
            <BodyWeightIcon
              width={defaultScale(40)}
              height={defaultScale(40)}
              stroke={selectedEquipment === 'bodyweight' ? Theme.WHITE : Theme.BLACK}
            />
          )}
          isSelected={selectedEquipment === 'bodyweight'}
          onPress={() => onEquipmentSelect('bodyweight')}
          height={defaultScale(120)}
          width='100%'
          titleStyle={sharedStyles.bookingSelectionTitle}
          subTitleStyle={sharedStyles.bookingSelectionSubtitle}
          overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
          style={sharedStyles.selectionContainer}
        />
        <SelectionContainer
          title={t('settings:dumbbells')}
          subTitle={t('settings:useYourOwnSet')}
          icon={(
            <DumbbellsIcon
              width={defaultScale(40)}
              height={defaultScale(40)}
              stroke={selectedEquipment === 'dumbbells' ? Theme.WHITE : Theme.BLACK}
            />
          )}
          isSelected={selectedEquipment === 'dumbbells'}
          onPress={() => onEquipmentSelect('dumbbells')}
          height={defaultScale(120)}
          width='100%'
          titleStyle={sharedStyles.bookingSelectionTitle}
          subTitleStyle={sharedStyles.bookingSelectionSubtitle}
          overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
          style={sharedStyles.selectionContainer}
        />
        <SelectionContainer
          title={t('settings:benchAndDumbbells')}
          subTitle={t('settings:benchAndDumbbells')}
          icon={(
            <BenchAndDumbbellsIcon
              width={defaultScale(40)}
              height={defaultScale(40)}
              stroke={selectedEquipment === 'benchAndDumbbells' ? Theme.WHITE : Theme.BLACK}
            />
          )}
          isSelected={selectedEquipment === 'benchAndDumbbells'}
          onPress={() => onEquipmentSelect('benchAndDumbbells')}
          height={defaultScale(120)}
          width='100%'
          titleStyle={sharedStyles.bookingSelectionTitle}
          subTitleStyle={sharedStyles.bookingSelectionSubtitle}
          overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
          style={sharedStyles.selectionContainer}
        />
        <SelectionContainer
          title={t('settings:smartHomeGym')}
          subTitle={t('settings:fitillionBenchAndBands')}
          icon={(
            <BenchIcon
              width={defaultScale(40)}
              height={defaultScale(40)}
              stroke={selectedEquipment === 'smartHomeGym' ? Theme.WHITE : Theme.BLACK}
            />
          )}
          isSelected={selectedEquipment === 'smartHomeGym'}
          onPress={() => onEquipmentSelect('smartHomeGym')}
          height={defaultScale(120)}
          width='100%'
          titleStyle={sharedStyles.bookingSelectionTitle}
          subTitleStyle={sharedStyles.bookingSelectionSubtitle}
          overrideLightStyles={{ defaultSubtitleColor: Theme.GREY_MEDIUM }}
          style={sharedStyles.selectionContainer}
        />
      </View>
    </ScrollView>
  );
}
